export default "__VITE_ASSET__2b7ba423__"